<template>
  <div class="main">
    <div class="content">
      <div class="course">
        <div class="course-tabs">
          <div class="tab-list">
            <p v-for="item in courseModuleList" :key="item" class="tab" :class="{'active':  item.id === '1'}" @click="tabIndex = item.id">{{ item.name }}</p>
          </div>
        </div>
        <div class="course-list">
          <ul>
            <li v-for="(item, index) in courseList" :key="index">
              <div class="course-img">
                <img :src="item.image" alt="">
              </div>
              <div class="course-info">
                <p class="course-title">{{ item.name }}</p>
                <!-- <p class="course-teacher"> 
                  <span>主讲老师：</span>
                  <span class="teacher-name">朱先波</span>
                </p> -->
              </div>
            </li>
          </ul>
        </div>
      </div>
      <pagination
        :num="num"
        :limit="limit"
        @getNew="getNew"
        v-if="num"
      ></pagination>
    </div>
  </div>
</template>
<script>
import pagination from "@/components/pc/pagination.vue";
export default {
  name: 'advicePage',
  components: {
    pagination,
  },
  data () {
    return {
      tabIndex: '1',
      num: 10, //数据总个数
      limit: 10, //一页显示几个
      nowPage: 1, //当前页码
      courseList: [],
      courseModuleList: []
    }
  },
  created () {
    this.ID = this.$route.query.ID
    this.getModuleList()
  },
  methods: {
    getModuleList() {
      this.$axios.post(`/v1/qn/courseModuleList`, { area_id: this.ID }).then((res) => {
        if (res.code == 0) {
          this.courseModuleList = res.data.data;
          if (res.data.data.length > 0) {
            this.getList(res.data.data[0].id)
          }
        }
      });
    },
    getList (id) {
      this.tabIndex = id;
      this.courseList = [];
      this.$axios.post(`/v1/qn/courseList`, { area_id: this.ID, module_id: id }).then((res) => {
        if (res.code == 0) {
          this.courseList = res.data.data;
        }
      });
    },
    // 翻页
    getNew(nowPage) {
      this.nowPage = nowPage;
      this.getList();
    },
  }
}
</script>
<style lang="scss" scoped>
.main {
  background-color: #F5F6F7;
  .content {
    margin: 0 auto;
    margin-top: 10px;
    padding-top: 10px;
    padding-bottom: 70px;
    background-color: #FFFFFF;
    border-top: 10px solid #F5F6F7;
    .course {
      padding: 28px;
      .course-tabs {
        margin-top: 40px;
        overflow: auto;
        .tab-list {
          display: flex;
          width: 1500px;
        }
        .tab {
          height: 58px;
          padding: 0px 24px;
          background: #F0F6FF;
          border-radius: 5px 5px 5px 5px;
          font-weight: 500;
          font-size: 24px;
          color: #7EA0F0;
          line-height: 58px;
          text-align: center;
          margin: 0 12px;
        }
        .active {
          cursor: pointer;
          background: #366CEC;
          color: #FFFFFF;
        }
      }
      .course-list {
        margin-top: 20px;
        ul {
          display: flex;
          flex-wrap: wrap;
          li {
            margin: 12px 6px;
            .course-img {
              width: 334px;
              height: 204px;
              border-radius: 10px 10px 0px 0px;
              img {
                width: 100%;
                height: 100%;
                border-radius: 10px 10px 0px 0px;
              }
            }
            .course-info {
              width: 334px;
              height: 134px;
              padding: 24px 20px;
              box-sizing: border-box;
              background: #FFFFFF;
              box-shadow: 0px 10px 18px 1px rgba(180,180,180,0.16);
              border-radius: 0px 0px 10px 10px;
              .course-title {
                font-weight: bold;
                font-size: 24px;
                color: #333333;
                line-height: 25px;
                text-align: left;
                margin-top: 12px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              }
              .course-teacher {
                display: flex;
                align-items: center;
                margin-top: 20px;
                span {
                  font-weight: bold;
                  font-size: 22px;
                  line-height: 23px;
                  color: #666666;
                  text-align: left;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>